'use strict';

var buildNumberUnitMethods = require('../internal/buildNumberUnitMethods');

buildNumberUnitMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/build/buildNumberUnitMethodsCall.js
// module id = 3
// module chunks = 0